import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import "../index.css";
import { toast } from "react-toastify";
import { APIURL } from "../../../Config";
import demoExcel from "../../../image/Demo4.xlsx";
import Pagination from "../../Pagination/Pagination";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";
import { Modal } from "react-bootstrap";
import WorkspaceProfileDetails from "../../WorkspaceProfileDetails";
import EmpOutstandingSummary from "../../EmpOutstandingSummary";

// const demoExcel = "../../../image/Book1.xlsx";

function ManageEmploye({ workSpace }) {
  const token = localStorage.getItem("token");
  const emailid = localStorage.getItem("corpadminmail");
  const email = localStorage.getItem("emailId");
  const corporateId = localStorage.getItem("corporateId");

  const workspaceid = localStorage.getItem("workspace");
  const tableRef = React.useRef(null);
  const tableSummary = React.useRef(null);
  const tableUnpaid = React.useRef(null);
  const [tncSign, setTncSign] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [manageEmp, SetManageEmp] = useState([]);
  const [empSummary, SetEmpSummary] = useState([]);
  const [empUnpaid, SetEmpUnpaid] = useState([]);
  const [empDetails, setEmpDetails] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [keyName, setKeyName] = useState("mobile");
  const [month, setMonth] = useState(0);
  const [months, setMonths] = useState([]);
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState(false);
  const [showPrePage, setShowPrePage] = useState(100);
  const fileInputRef = useRef(null);
  const fileInputRefsalary = useRef(null);
  const fileInputRefs = useRef(null);

  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const [error, setError] = useState(null);
  const [profileData, setProfileData] = useState([]);
  const [showUpload, SetShowUpload] = useState(false);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const [limitExtend, setLimitExtend] = useState("");
  const [getlimitExtend, setGetLimitExtend] = useState("");
  const [manageEmpStatus, setManageEmpStatus] = useState(false);
  const [rejectedEmp, setRejectedEmp] = useState(false);
  const [unapaidEmp, setUnpaidEmp] = useState(false);
  const [empSummaryStatus, setEmpSummaryStatus] = useState(true);
  const [keyValue, setKeyValue] = useState("");
  const [activeTab, setActiveTab] = useState("admin");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const manageemployeesStatus = (mobile, status) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/employerstatus`, {
        method: "POST",
        data: {
          ownerEmail: emailid,
          ownerEmailId: emailid,
          mobile: mobile,
          status: status,
        },
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        ManageEmployeesList();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  function getProfileDetails() {
    const data = { emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/corporate/getprofiledetails`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setProfileData(response?.data);
        if (response.data?.assuranceTc) {
          setTncSign(true);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  }

  const LoginSchema = Yup.object().shape({
    file: Yup.mixed().required("A file is required"),
  });

  const UploadSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    limitassigned: Yup.string().required("Required"),
    // producttype: Yup.string().required("Required"),
  });

  useEffect(() => {
    getProfileDetails();

    // ManageEmployeesList();
  }, []);
  const handleInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const searchHandler = () => {
    const search = { [keyName]: searchInput, email: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/employee/searchdetails`, {
        method: "POST",
        data: search,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        SetManageEmp(response?.data);
        setSearchInput("");

        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  console.log("summary details:::", manageEmp);
  function ManageEmployeesList(key, status) {
    setIsLoader(true);
    axios
      .request(`${APIURL}/empSummary/${emailid}/${key}/${status}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        SetManageEmp(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  }
  const summary = () => {
    const data = { email: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/employee/summary`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        if (typeof response?.data !== "string") {
          SetEmpSummary(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long" });

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const monthsArray = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(currentYear, now.getMonth() - i, 1);
      const monthName = getMonthName(monthDate);
      monthsArray.push({
        name: `${monthName} ${currentYear}`,
        value: i.toString(),
      });
    }

    setMonths(monthsArray);
    setMonth("0");
  }, []);

  const Unpaidemployees = () => {
    const data = { ownerEmail: emailid };
    setIsLoader(true);
    axios
      .request(`${APIURL}/employee/unpaidreport`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        if (typeof response?.data !== "string") {
          SetEmpUnpaid(response?.data);
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const limitExtendChange = (e) => {
    setLimitExtend(e.target.value);
  };
  const handleSubmit = (limitExtend) => {
    console.log("getlimitExtend::: ", getlimitExtend);
    if (getlimitExtend.limitAssign > limitExtend) {
      toast.warning("Limit must be higher.");
    } else {
      const data = {
        emailid: email,
        ownerEmail: emailid,
        mobile: getlimitExtend.mobileNo,
        limitassigned: limitExtend,
      };
      axios
        .request(`${APIURL}/corporate/updatelimitassigned`, {
          method: "POST",
          data: data,
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response", response);
          setShowModal(false);
          setManageEmpStatus(false);
          setEmpSummaryStatus(true);
          toast.success("Limit extend successfully...");
        })
        .catch((error) => {
          console.log("error", error);
          toast.warning("Invalid...");
        });
    }
  };
  // if (isLoader) {
  //   return (
  //     <div className="text-center">
  //       <div className="spinner-border text-success" role="status">
  //         <span className="sr-only">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link tab-item ${
                activeTab === "admin" ? "active" : ""
              }`}
              id="admin-tab"
              data-bs-toggle="tab"
              data-bs-target="#admin"
              type="button"
              role="tab"
              aria-controls="admin"
              aria-selected={activeTab === "admin" ? "true" : "false"}
              onClick={() => {
                SetShowUpload(false);
                setRejectedEmp(false);
                setManageEmpStatus(false);
                setUnpaidEmp(false);
                setEmpSummaryStatus(true);
                handleTabClick("admin");
              }}
            >
              Upload employee data
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className="nav-link  tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
              onClick={() => ManageEmployeesList()}
            >
              Manage employees
            </button>
          </li> */}
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link tab-item ${
                activeTab === "Attendance" ? "active" : ""
              }`}
              id="Attendance-tab"
              data-bs-toggle="tab"
              data-bs-target="#Attendance"
              type="button"
              role="tab"
              aria-controls="Attendance"
              aria-selected={activeTab === "Attendance" ? "true" : "false"}
              onClick={() => {
                SetShowUpload(false);
                setRejectedEmp(false);
                setManageEmpStatus(false);
                setUnpaidEmp(false);
                setEmpSummaryStatus(false);
                handleTabClick("Attendance");
              }}
            >
              Attendance Upload
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link tab-item ${
                activeTab === "Salary" ? "active" : ""
              }`}
              id="Salary-tab"
              data-bs-toggle="tab"
              data-bs-target="#Salary"
              type="button"
              role="tab"
              aria-controls="Salary"
              aria-selected={activeTab === "Salary" ? "true" : "false"}
              onClick={() => {
                SetShowUpload(false);
                setRejectedEmp(false);
                setManageEmpStatus(false);
                setUnpaidEmp(false);
                setEmpSummaryStatus(false);
                handleTabClick("Salary");
              }}
            >
              Salary Upload
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link tab-item ${
                activeTab === "upload" ? "active" : ""
              }`}
              id="upload-tab"
              data-bs-toggle="tab"
              data-bs-target="#upload"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected={activeTab === "upload" ? "true" : "false"}
              onClick={() => {
                summary();
                SetShowUpload(false);
                setRejectedEmp(false);
                setManageEmpStatus(false);
                setUnpaidEmp(false);
                setEmpSummaryStatus(true);

                handleTabClick("upload");
                summary();
              }}
            >
              Employee summary
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link tab-item ${
                activeTab === "outstanding" ? "active" : ""
              }`}
              id="outstanding-tab"
              data-bs-toggle="tab"
              data-bs-target="#outstanding"
              type="button"
              role="tab"
              aria-controls="outstanding"
              aria-selected={activeTab === "outstanding" ? "true" : "false"}
              onClick={() => {
                SetShowUpload(false);
                setRejectedEmp(false);
                setManageEmpStatus(false);
                setUnpaidEmp(false);
                setEmpSummaryStatus(false);
                handleTabClick("outstanding");
              }}
            >
              Outstanding summary
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className="nav-link tab-item "
              id="agreement-tab"
              data-bs-toggle="tab"
              data-bs-target="#agreement"
              type="button"
              role="tab"
              aria-controls="agreement"
              aria-selected="false"
              onClick={Unpaidemployees}
            >
              Unpaid employees
            </button>
          </li> */}
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div>
            {manageEmpStatus && (
              <div>
                {!empDetails ? (
                  <div className="pt-3">
                    <div className="card">
                      <div className="p-3 d-flex flex-column flex-md-row ">
                        <DownloadTableExcel
                          filename="Employee Details"
                          sheet="users"
                          currentTableRef={tableRef.current}
                        >
                          <button
                            className="btn btn-success mb-3 mb-md-0"
                            style={{ width: "120px", background: "#66a725" }}
                          >
                            Download
                          </button>
                        </DownloadTableExcel>
                        <button
                          className="btn btn-secondary ml-2"
                          onClick={() => {
                            setManageEmpStatus(false);
                            setEmpSummaryStatus(true);
                            setSearch(false);
                          }}
                          style={{ width: "80px" }}
                        >
                          Back
                        </button>
                        <div className="justify-content-between ml-auto">
                          <div className="d-flex flex-column flex-md-row align-items-center">
                            <select
                              className="form-select mx-md-2 mb-2 mb-md-0"
                              id="lang"
                              onChange={(e) => setKeyName(e.target.value)}
                              value={keyName}
                            >
                              <option value="mobile">Mobile No.</option>
                              <option value="lid">Loan id</option>
                              <option value="name">Name</option>
                            </select>
                            <input
                              className="form-control"
                              style={{
                                height: "38px",
                                width: "100%",
                                background: "#fff",
                              }}
                              type="text"
                              placeholder="Search"
                              value={searchInput}
                              onChange={handleInputChange}
                            />
                            <button
                              className="btn btn-success ml-md-2 mt-2 mt-md-0"
                              style={{ background: "#66a725", color: "#fff" }}
                              onClick={() => {
                                searchHandler();
                                setSearch(true);
                              }}
                            >
                              {isLoader ? (
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "Search"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 pt-2">
                        <div className="table-responsive">
                          {isLoader ? (
                            <div className="d-flex justify-content-center">
                              <div
                                className="spinner-border text-success"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <table className="table table-striped">
                              <thead>
                                <tr>
                                  <th style={{ textAlign: "center" }}>
                                    Sr. No
                                  </th>
                                  {keyValue === "employeeuploaded" &&
                                    !search && (
                                      <th style={{ textAlign: "center" }}>
                                        Uploaded Date
                                      </th>
                                    )}

                                  {keyValue == "employeerejected" &&
                                    !search && (
                                      <th style={{ textAlign: "center" }}>
                                        Rejected Date
                                      </th>
                                    )}
                                  {keyValue == "employeeapproved" &&
                                    !search && (
                                      <th style={{ textAlign: "center" }}>
                                        Approved Date
                                      </th>
                                    )}
                                  {keyValue == "disbursed" && !search && (
                                    <th style={{ textAlign: "center" }}>
                                      Disbursed Date
                                    </th>
                                  )}
                                  <th style={{ textAlign: "center" }}>Name</th>
                                  <th style={{ textAlign: "center" }}>
                                    Mobile
                                  </th>
                                  <th style={{ textAlign: "center" }}>Lid</th>
                                  <th style={{ textAlign: "center" }}>
                                    Limit assigned
                                  </th>
                                  <th style={{ textAlign: "center" }}>
                                    Limit used
                                  </th>
                                  <th style={{ textAlign: "center" }}>
                                    Unpaid amt
                                  </th>
                                  {rejectedEmp && (
                                    <th style={{ textAlign: "center" }}>
                                      Remark
                                    </th>
                                  )}

                                  {/* <th
                                    style={{
                                      width: "150px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    Extend Limit
                                  </th> */}
                                  {keyValue != "employeerejected" && (
                                    <th style={{ textAlign: "center" }}>
                                      Status
                                    </th>
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {manageEmp
                                  ?.slice(pagination.start, pagination.end)
                                  .map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>

                                      {!search &&
                                        (keyValue === "employeeuploaded" ||
                                          keyValue === "employeerejected" ||
                                          keyValue === "employeeapproved" ||
                                          keyValue === "disbursed") && (
                                          <td>
                                            {item.anydate
                                              ? moment(item.anydate).format(
                                                  "DD-MM-YYYY, h:mm:ss A"
                                                )
                                              : ""}
                                          </td>
                                        )}

                                      <td>{item.empName}</td>
                                      <td style={{ textAlign: "center" }}>
                                        {item.mobileNo}
                                      </td>
                                      <td
                                        onClick={() => {
                                          if (item.loanid) {
                                            setEmpDetails(true);
                                            setLid(item.loanid);
                                          }
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          color: "blue",
                                          textAlign: "center",
                                        }}
                                      >
                                        {item.loanid}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {item.limitAssign}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {item.limitUsed}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {item.unpaidAmount}
                                      </td>
                                      {rejectedEmp && <td>{item?.remark}</td>}
                                      {/* <td style={{ textAlign: "center" }}>
                                        <button
                                          className="btn btn-success"
                                          style={{ width: "100px" }}
                                          onClick={() => {
                                            setShowModal(true);
                                            setLimitExtend(item.limitAssign);
                                            setGetLimitExtend(item);
                                          }}
                                        >
                                          Extend
                                        </button>
                                      </td> */}
                                      {keyValue != "employeerejected" && (
                                        <td style={{ width: "120px" }}>
                                          <div className="d-flex">
                                            <button
                                              style={{
                                                backgroundColor:
                                                  item?.status === "ACTIVE"
                                                    ? "#28a745"
                                                    : "#f8f9fa",
                                                color:
                                                  item?.status === "ACTIVE"
                                                    ? "white"
                                                    : "#6c757d",
                                                border: "1px solid #ced4da",
                                                padding: "0.375rem 0.75rem",
                                                borderRadius: "0.25rem",
                                                cursor:
                                                  item?.status === "ACTIVE"
                                                    ? "not-allowed"
                                                    : "pointer",
                                                transition: "all 0.2s ease",
                                                marginRight: "0.5rem",
                                              }}
                                              onMouseOver={(e) => {
                                                if (item?.status !== "ACTIVE") {
                                                  e.target.style.backgroundColor =
                                                    "#28a745";
                                                  e.target.style.color =
                                                    "white";
                                                }
                                              }}
                                              onMouseOut={(e) => {
                                                if (item?.status !== "ACTIVE") {
                                                  e.target.style.backgroundColor =
                                                    "#f8f9fa";
                                                  e.target.style.color =
                                                    "#6c757d";
                                                }
                                              }}
                                              onClick={() => {
                                                if (item?.status !== "ACTIVE") {
                                                  manageemployeesStatus(
                                                    item.mobileNo,
                                                    "ACTIVE"
                                                  );
                                                  setEmpSummaryStatus(true);
                                                  setManageEmpStatus(false);
                                                }
                                              }}
                                              disabled={
                                                item?.status === "ACTIVE"
                                              }
                                            >
                                              Activate
                                            </button>

                                            <button
                                              style={{
                                                backgroundColor:
                                                  item?.status === "INACTIVE"
                                                    ? "#dc3545"
                                                    : "#f8f9fa",
                                                color:
                                                  item?.status === "INACTIVE"
                                                    ? "white"
                                                    : "#6c757d",
                                                border: "1px solid #ced4da",
                                                padding: "0.375rem 0.75rem",
                                                borderRadius: "0.25rem",
                                                cursor:
                                                  item?.status === "INACTIVE"
                                                    ? "not-allowed"
                                                    : "pointer",
                                                transition: "all 0.2s ease",
                                              }}
                                              onMouseOver={(e) => {
                                                if (
                                                  item?.status !== "INACTIVE"
                                                ) {
                                                  e.target.style.backgroundColor =
                                                    "#dc3545";
                                                  e.target.style.color =
                                                    "white";
                                                }
                                              }}
                                              onMouseOut={(e) => {
                                                if (
                                                  item?.status !== "INACTIVE"
                                                ) {
                                                  e.target.style.backgroundColor =
                                                    "#f8f9fa";
                                                  e.target.style.color =
                                                    "#6c757d";
                                                }
                                              }}
                                              onClick={() => {
                                                if (
                                                  item?.status !== "INACTIVE"
                                                ) {
                                                  manageemployeesStatus(
                                                    item.mobileNo,
                                                    "INACTIVE"
                                                  );
                                                  setEmpSummaryStatus(true);
                                                  setManageEmpStatus(false);
                                                }
                                              }}
                                              disabled={
                                                item?.status === "INACTIVE"
                                              }
                                            >
                                              Inactive
                                            </button>
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}
                          <Modal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            style={{ background: "rgb(255 255 255 / 40%)" }}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Limit Extend</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <input
                                type="number"
                                value={limitExtend}
                                onChange={limitExtendChange}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  boxSizing: "border-box",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  marginTop: "10px",
                                  fontSize: "18px",
                                }}
                              />
                              <div className="d-flex mt-3 justify-content-end">
                                <button
                                  className="btn btn-secondary"
                                  style={{ width: "100px" }}
                                  onClick={() => setShowModal(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn btn-success ml-2"
                                  style={{
                                    width: "100px",
                                    background: "#66a725",
                                  }}
                                  onClick={() => handleSubmit(limitExtend)}
                                >
                                  Submit
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        {manageEmp && manageEmp.length !== 0 && (
                          <Pagination
                            showPrePage={showPrePage}
                            onPaginationChange={onPaginationChange}
                            total={manageEmp.length}
                          />
                        )}
                        <table
                          className="table table-striped"
                          style={{ display: "none" }}
                          ref={tableRef}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              {keyValue == "employeeuploaded" && (
                                <th style={{ textAlign: "center" }}>
                                  Uploaded Date
                                </th>
                              )}
                              {keyValue == "employeerejected" && (
                                <th style={{ textAlign: "center" }}>
                                  Rejected Date
                                </th>
                              )}
                              {keyValue == "employeeapproved" && (
                                <th style={{ textAlign: "center" }}>
                                  Approved Date
                                </th>
                              )}
                              {keyValue == "disbursed" && (
                                <th style={{ textAlign: "center" }}>
                                  Disbursed Date
                                </th>
                              )}
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Mobile</th>
                              <th style={{ textAlign: "center" }}>Lid</th>
                              <th style={{ textAlign: "center" }}>
                                Limit assigned
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Limit used
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Unpaid amt
                              </th>
                              {rejectedEmp && (
                                <th style={{ textAlign: "center" }}>Remark</th>
                              )}

                              {/* <th
                                style={{
                                  width: "150px",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                Extend Limit
                              </th> */}
                              {!rejectedEmp && (
                                <th style={{ textAlign: "center" }}>Status</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {manageEmp.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1 + pagination.start}</td>

                                {(keyValue == "employeeuploaded" ||
                                  keyValue == "employeerejected" ||
                                  keyValue == "employeeapproved" ||
                                  keyValue == "disbursed") && (
                                  <td>
                                    {item.anydate
                                      ? moment(item.anydate).format(
                                          "DD-MM-YYYY, h:mm:ss A"
                                        )
                                      : ""}
                                  </td>
                                )}

                                <td>{item.empName}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.mobileNo}
                                </td>
                                <td
                                  onClick={() => {
                                    if (item.loanid) {
                                      setEmpDetails(true);
                                      setLid(item.loanid);
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    textAlign: "center",
                                  }}
                                >
                                  {item.loanid}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.limitAssign}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.limitUsed}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.unpaidAmount}
                                </td>
                                {rejectedEmp && <td>{item?.remark}</td>}
                                {/* <td style={{ textAlign: "center" }}>
                                  <button
                                    className="btn btn-success"
                                    style={{ width: "100px" }}
                                    onClick={() => {
                                      setShowModal(true);
                                      setLimitExtend(item.limitAssign);
                                      setGetLimitExtend(item);
                                    }}
                                  >
                                    Extend
                                  </button>
                                </td> */}
                                {!rejectedEmp && (
                                  <td style={{ textAlign: "center" }}>
                                    {item.status}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <button
                      className="btn btn-secondary mt-3"
                      onClick={() => setEmpDetails(false)}
                      style={{ width: "80px" }}
                    >
                      Back
                    </button>
                    <WorkspaceProfileDetails lid={lid} />
                  </>
                )}
              </div>
            )}
          </div>

          <div
            className="tab-pane fade show active"
            id="admin"
            role="tabpanel"
            aria-labelledby="admin-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-4">
                  {workSpace?.status === "Approved" &&
                  workSpace?.assuranceTc &&
                  workSpace?.model !== null &&
                  workSpace?.address !== null &&
                  // workSpace?.companyType !== null &&
                  // workSpace?.hrApp !== null &&
                  workSpace?.fundEmployees !== null ? (
                    <>
                      <div className="d-flex ">
                        <div>
                          <p style={{ color: "blue" }} className="mt-2">
                            {console.log("profileData::: ", profileData)}
                            {workSpace.code == "A+"
                              ? " We are currently restricting employee withdrawal to Rs.25,000 (which will be gradually increased to your assigned limit in course of time)"
                              : workSpace.code == "A"
                              ? "We are currently restricting employee withdrawal to Rs.25,000 (which will be gradually increased to your assigned limit in course of time)"
                              : workSpace.code == "B"
                              ? "We are currently restricting employee withdrawal to Rs.5,000 (which will be gradually increased to your assigned limit in course of time)"
                              : ""}
                          </p>
                        </div>

                        <div className="justify-content-end  ml-auto">
                          {!showUpload ? (
                            <button
                              className="btn btn-success "
                              style={{ width: "120px", background: "#66a725" }}
                              onClick={() => SetShowUpload(true)}
                            >
                              Add
                            </button>
                          ) : (
                            <button
                              className="mr-3 btn btn-secondary"
                              style={{ width: "120px" }}
                              onClick={() => SetShowUpload(false)}
                            >
                              Back
                            </button>
                          )}
                        </div>
                      </div>
                      {!showUpload ? (
                        <Formik
                          initialValues={{
                            file: null,
                          }}
                          validationSchema={LoginSchema}
                          onSubmit={(values, { resetForm }) => {
                            const formData = new FormData();
                            formData.append("Files", values.file);
                            formData.append("emailid", email);
                            formData.append("ownerEmail", emailid);
                            formData.append("workspaceId", workspaceid);
                            for (let pair of formData.entries()) {
                              console.log(pair[0], pair[1]);
                            }
                            setIsLoader(true);
                            axios
                              .request(`${APIURL}/employee/detailsupload`, {
                                method: "POST",
                                data: formData,
                              })
                              .then((response) => {
                                console.log("response::", response);
                                setIsLoader(false);
                                toast.success(response?.data);
                                resetForm();
                                fileInputRef.current.value = null;
                              })
                              .catch((error) => {
                                console.log("error", error);
                                setIsLoader(false);
                                toast.warning("Invalid...");
                                fileInputRef.current.value = null;
                                resetForm();
                              });
                          }}
                        >
                          {({ touched, errors, setFieldValue }) => (
                            <>
                              <Form className="pt-4">
                                <div
                                  className="row"
                                  style={{ alignItems: "center" }}
                                >
                                  <div className="col-lg-9 col-md-9 col-sm-12">
                                    <div className="form-group">
                                      <label htmlFor="file">Upload File</label>
                                      <input
                                        id="file"
                                        name="file"
                                        type="file"
                                        accept=".xlsx, .xls"
                                        ref={fileInputRef}
                                        className={`form-control ${
                                          touched.file && errors.file
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        onChange={(event) => {
                                          const file =
                                            event.currentTarget.files[0];
                                          setFieldValue("file", file);
                                        }}
                                      />
                                      <ErrorMessage
                                        name="file"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3 col-sm-12  d-flex justify-content-center">
                                    <a
                                      download="Demo.xlsx"
                                      href={demoExcel}
                                      style={{
                                        width: "200px",
                                        backgroundColor: "#6c757d",
                                      }}
                                      className="btn btn-secondary mt-3 ml-auto"
                                    >
                                      Download Demo File
                                    </a>
                                  </div>
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-success mt-3"
                                  style={{ backgroundColor: "#66a725" }}
                                >
                                  {isLoader ? (
                                    <div
                                      className="spinner-border text-success"
                                      role="status"
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                                {isLoader && (
                                  <div className="text-center mt-3">
                                    <p>
                                      Please be patient we are simultaneously
                                      updating employee limits
                                    </p>
                                  </div>
                                )}
                              </Form>
                            </>
                          )}
                        </Formik>
                      ) : (
                        <Formik
                          initialValues={{
                            name: "",
                            mobile: "",
                            // producttype: "Credit Line",
                            limitassigned: "",
                          }}
                          validationSchema={UploadSchema}
                          onSubmit={(values, { resetForm }) => {
                            if (
                              !values.name ||
                              !values.mobile ||
                              !values.limitassigned
                            ) {
                              toast.warning("All field required...");
                            } else {
                              const data = {
                                emailid: email,
                                name: values.name,
                                // producttype: values.producttype,
                                mobile: values.mobile,
                                limitassigned: values.limitassigned,
                                workspaceId: workspaceid,
                                ownerEmail: emailid,
                              };
                              setIsLoader(true);
                              axios
                                .request(`${APIURL}/corporate/addemployee`, {
                                  method: "POST",
                                  data: data,
                                  headers: {
                                    Authentication: token,
                                  },
                                })
                                .then((response) => {
                                  setIsLoader(false);
                                  SetShowUpload(false);
                                  toast.success(response?.data);
                                  resetForm();
                                })
                                .catch((error) => {
                                  console.log("error", error);
                                  setIsLoader(false);
                                  SetShowUpload(false);
                                  toast.warning("Invalid...");
                                  resetForm();
                                });
                            }
                          }}
                        >
                          {({ touched, errors }) => (
                            <Form className="pt-4">
                              <div>
                                <label>Your Name*</label>
                                <Field
                                  type="text"
                                  name="name"
                                  placeholder="Enter name"
                                  className={`form-control ${
                                    touched.name && errors.name
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="name"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="mt-2">
                                <label>Mobile*</label>
                                <Field
                                  type="number"
                                  name="mobile"
                                  placeholder="Enter mobile"
                                  className={`form-control ${
                                    touched.mobile && errors.mobile
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="mobile"
                                  className="invalid-feedback"
                                />
                              </div>
                              {/* <div className="mt-2">
                                <label>Product Type*</label>
                                <Field
                                  as="select"
                                  name="producttype"
                                  className={`form-control ${
                                    touched.producttype && errors.producttype
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                >
                                  <option value="">Select Type</option>
                                  <option value="Credit Line">
                                    Credit Line
                                  </option>
                                  <option value="Personal Loan">
                                    Personal Loan
                                  </option>
                                </Field>
                                <ErrorMessage
                                  component="div"
                                  name="producttype"
                                  className="invalid-feedback"
                                />
                              </div> */}
                              <div className="mt-2">
                                <label>Monthly Salary*</label>
                                <Field
                                  type="number"
                                  name="limitassigned"
                                  placeholder="Monthly Salary"
                                  className={`form-control ${
                                    touched.limitassigned &&
                                    errors.limitassigned
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  component="div"
                                  name="limitassigned"
                                  className="invalid-feedback"
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-success mt-3"
                                style={{ backgroundColor: "#66a725" }}
                              >
                                {isLoader ? (
                                  <div
                                    className="spinner-border text-success"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            </Form>
                          )}
                        </Formik>
                      )}
                    </>
                  ) : (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {workSpace?.status === "Pending" &&
                      workSpace?.assuranceTc ? (
                        <p
                          className="m-0"
                          style={{
                            color: "orange",
                            fontSize: "18px",
                          }}
                        >
                          Your workspace has been successfully set up. We are
                          now finalizing the backend and will notify you as soon
                          as it is complete.
                        </p>
                      ) : workSpace?.status === "Rejected" &&
                        workSpace?.assuranceTc ? (
                        <p
                          className="m-0"
                          style={{
                            color: "red",
                            fontSize: "22px",
                          }}
                        >
                          Your workspace has been Rejected.
                        </p>
                      ) : (
                        <p
                          className="m-0"
                          style={{
                            color: "red",
                            fontSize: "22px",
                          }}
                        >
                          Complete your profile
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="upload"
            role="tabpanel"
            aria-labelledby="upload-tab"
          >
            <>
              {empSummaryStatus && empSummary && (
                <div className="card">
                  <div className="p-3 pt-4">
                    <div className="d-flex">
                      <DownloadTableExcel
                        filename="Employee Summary"
                        sheet="users"
                        currentTableRef={tableSummary.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                    </div>

                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped mt-3">
                          <thead>
                            <th className="text-center">Employees Uploaded</th>
                            {/* <th className="text-center">Employees Rejected</th>
                            <th className="text-center">Employees Approved</th> */}
                            <th className="text-center">Employees Disbursed</th>
                            <th className="text-center">Limit Assigned</th>
                            <th className="text-center">Limit Used</th>
                            <th className="text-center">Utilization %</th>
                            {/* <th className="text-center">Unpaid</th> */}
                          </thead>

                          <tbody>
                            {empSummary?.map((item, i) => (
                              <tr key={i}>
                                {/* <td>{i + 1}</td>
                                <td>{item.month}</td> */}
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    ManageEmployeesList("employeeuploaded", i);
                                    setRejectedEmp(false);
                                    setManageEmpStatus(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("employeeuploaded");
                                  }}
                                >
                                  {item.uploaded}
                                </td>

                                {/* <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    ManageEmployeesList("employeerejected", i);
                                    setManageEmpStatus(true);
                                    setRejectedEmp(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("employeerejected");
                                  }}
                                >
                                  {item.rejected}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    ManageEmployeesList("employeeapproved", i);
                                    setRejectedEmp(false);
                                    setManageEmpStatus(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("employeeapproved");
                                  }}
                                >
                                  {item.approved}
                                </td> */}
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    ManageEmployeesList("disbursed", 0);
                                    setRejectedEmp(false);
                                    setManageEmpStatus(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("disbursed");
                                  }}
                                >
                                  {item.disbursed}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {parseInt(item.limitamountassigned)}
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    ManageEmployeesList("limitused", i);
                                    setRejectedEmp(false);
                                    setManageEmpStatus(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("limitused");
                                  }}
                                >
                                  {item?.limitused}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {Number(item.utilizationamount).toFixed(2)}
                                </td>
                                {/* <td
                                  style={{
                                    textAlign: "center",
                                    color: "blue",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    // Unpaidemployees();
                                    ManageEmployeesList("unpaidemployee", i);
                                    setRejectedEmp(false);
                                    setUnpaidEmp(true);
                                    setEmpSummaryStatus(false);
                                    setKeyValue("unpaidemployee");
                                  }}
                                >
                                  {item?.unpaidcount}
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <table
                      className="table table-striped mt-3"
                      style={{ display: "none" }}
                      ref={tableSummary}
                    >
                      <thead>
                        <tr>
                          <th className="text-center">Employees Uploaded</th>
                          <th className="text-center">Employees Rejected</th>
                          <th className="text-center">Employees Approved</th>
                          <th className="text-center">Employees Disbursed</th>
                          <th className="text-center">Limit Assigned</th>
                          <th className="text-center">Limit Used</th>
                          <th className="text-center">Utilization %</th>
                          <th className="text-center">Unpaid</th>
                        </tr>
                      </thead>

                      <tbody>
                        {empSummary?.map((item, i) => (
                          <tr key={i}>
                            {/* <td>{i + 1}</td>
                                <td>{item.month}</td> */}
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   ManageEmployeesList("employeeuploaded", i);
                              //   setRejectedEmp(false);
                              //   setManageEmpStatus(true);
                              //   setEmpSummaryStatus(false);
                              //   setKeyValue("employeeuploaded");
                              // }}
                            >
                              {item.uploaded}
                            </td>

                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   ManageEmployeesList("employeerejected", i);
                              //   setManageEmpStatus(true);
                              //   setRejectedEmp(true);
                              //   setEmpSummaryStatus(false);
                              //   setKeyValue("employeerejected");
                              // }}
                            >
                              {item.rejected}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   ManageEmployeesList("employeeapproved", i);
                              //   setRejectedEmp(false);
                              //   setManageEmpStatus(true);
                              //   setEmpSummaryStatus(false);
                              //   setKeyValue("employeeapproved");
                              // }}
                            >
                              {item.approved}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   ManageEmployeesList("disbursed", 0);
                              //   setRejectedEmp(false);
                              //   setManageEmpStatus(true);
                              //   setEmpSummaryStatus(false);
                              //   setKeyValue("disbursed");
                              // }}
                            >
                              {item.disbursed}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {parseInt(item.limitamountassigned)}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   ManageEmployeesList("limitused", i);
                              //   setRejectedEmp(false);
                              //   setManageEmpStatus(true);
                              //   setEmpSummaryStatus(false);
                              //   setKeyValue("limitused");
                              // }}
                            >
                              {item?.limitused}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(item.utilizationamount).toFixed(2)}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                // Unpaidemployees();
                                // ManageEmployeesList("unpaidemployee", i);
                                // setRejectedEmp(false);
                                // setUnpaidEmp(true);
                                // setEmpSummaryStatus(false);
                                // setKeyValue("unpaidemployee");
                              }}
                            >
                              {item?.unpaidcount}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          </div>

          <div>
            {unapaidEmp && (
              <div className="pt-3">
                <div className="card">
                  <div className="p-3 d-flex justify-content-between align-items-center flex-md-row flex-column flex-md-row">
                    <div className="d-flex mb-3 mb-md-0">
                      <DownloadTableExcel
                        filename="Employee Unpaid"
                        sheet="users"
                        currentTableRef={tableUnpaid.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{ width: "120px", backgroundColor: "#66a725" }}
                        >
                          Download
                        </button>
                      </DownloadTableExcel>
                      <button
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                          setUnpaidEmp(false);
                          setEmpSummaryStatus(true);
                        }}
                        style={{ width: "80px" }}
                      >
                        Back
                      </button>
                    </div>
                    {/* <div className="mx-md-3 d-flex flex-row flex-md-row align-items-center">
                    <div>
                      <select
                        className="form-select mx-md-2 mb-md-0"
                        id="lang"
                        onChange={(e) => setMonth(e.target.value)}
                        value={month}
                      >
                        {months.map(({ name, value }) => (
                          <option key={value} value={value}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="ml-md-2">
                      <button
                        className="btn btn-success border"
                        style={{ background: "#66a725", color: "#fff" }}
                        onClick={Unpaidemployees}
                      >
                        {isLoader ? (
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "Search"
                        )}
                      </button>
                    </div>
                  </div> */}
                  </div>

                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="p-3 pt-2 table-responsive">
                      {!empDetails ? (
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>LID</th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Mobile</th>
                              <th style={{ textAlign: "center" }}>
                                Limit approved
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Limit used
                              </th>
                              <th style={{ textAlign: "center" }}>Unpaid</th>
                              {/* <th style={{ textAlign: "center" }}>Month</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {manageEmp &&
                              manageEmp.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td
                                    onClick={() => {
                                      if (item.lid) {
                                        setEmpDetails(true);
                                        setLid(item.loanid);
                                      }
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      color: "blue",
                                      textAlign: "center",
                                    }}
                                  >
                                    {item.loanid}
                                  </td>
                                  <td>{item.empName}</td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.mobileNo}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.limitAssign}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.limitUsed}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {Number(item.unpaidAmount).toFixed(2)}
                                  </td>
                                  {/* <td>{item.month}</td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      ) : (
                        <>
                          <button
                            className="btn btn-secondary mt-3"
                            onClick={() => setEmpDetails(false)}
                            style={{ width: "80px" }}
                          >
                            Back
                          </button>
                          <WorkspaceProfileDetails lid={lid} />
                        </>
                      )}
                    </div>
                  )}

                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableUnpaid}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>LID</th>
                        <th style={{ textAlign: "center" }}>Name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Limit approved</th>
                        <th style={{ textAlign: "center" }}>Limit used</th>
                        <th style={{ textAlign: "center" }}>Unpaid</th>
                        {/* <th style={{ textAlign: "center" }}>Month</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {manageEmp &&
                        manageEmp.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td
                              onClick={() => {
                                if (item.lid) {
                                  setEmpDetails(true);
                                  setLid(item.loanid);
                                }
                              }}
                              style={{
                                cursor: "pointer",
                                color: "blue",
                                textAlign: "center",
                              }}
                            >
                              {item.loanid}
                            </td>
                            <td>{item.empName}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.mobileNo}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.limitAssign}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.limitUsed}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {Number(item.unpaidAmount).toFixed(2)}
                            </td>
                            {/* <td>{item.month}</td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          <div
            className="tab-pane fade"
            id="outstanding"
            role="tabpanel"
            aria-labelledby="outstanding-tab"
          >
            <EmpOutstandingSummary />
          </div>
          <div
            className="tab-pane fade"
            id="Attendance"
            role="tabpanel"
            aria-labelledby="Attendance-tab"
          >
            <Formik
              initialValues={{
                file: null,
              }}
              validationSchema={LoginSchema}
              onSubmit={(values, { resetForm }) => {
                fileInputRef.current.value = null;
                resetForm();
                const formData = new FormData();
                formData.append("file", values.file);

                formData.append("uploadby", corporateId);
                for (let pair of formData.entries()) {
                  console.log(pair[0], pair[1]);
                }
                setIsLoader(true);
                axios
                  .request(`${APIURL}/attendanceUpload`, {
                    method: "POST",
                    data: formData,
                  })
                  .then((response) => {
                    console.log("response::", response);
                    setIsLoader(false);
                    toast.success(response?.data);
                    resetForm();
                    fileInputRefs.current.value = null;
                  })
                  .catch((error) => {
                    console.log("error", error);
                    setIsLoader(false);
                    toast.warning("Invalid...");
                    fileInputRefs.current.value = null;
                    resetForm();
                  });
              }}
            >
              {({ touched, errors, setFieldValue }) => (
                <>
                  <Form className="pt-4">
                    <div className="row" style={{ alignItems: "center" }}>
                      <div className="col-lg-9 col-md-9 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="file">Upload Attendance File</label>
                          <input
                            id="file"
                            name="file"
                            type="file"
                            accept=".xlsx, .xls"
                            ref={fileInputRefs}
                            className={`form-control ${
                              touched.file && errors.file ? "is-invalid" : ""
                            }`}
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              setFieldValue("file", file);
                            }}
                          />
                          <ErrorMessage
                            name="file"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-12  d-flex justify-content-center">
                        <a
                          download="Demo.xlsx"
                          href="https://tap.capitaltrust.in:8083/salarytap/downAttdemo"
                          style={{
                            width: "200px",
                            backgroundColor: "#6c757d",
                          }}
                          className="btn btn-secondary mt-3 ml-auto"
                        >
                          Download Demo File
                        </a>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-success mt-3"
                      style={{ backgroundColor: "#66a725" }}
                    >
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </Form>
                </>
              )}
            </Formik>
          </div>

          <div
            className="tab-pane fade"
            id="Salary"
            role="tabpanel"
            aria-labelledby="Salary-tab"
          >
            <Formik
              initialValues={{
                file: null,
              }}
              validationSchema={LoginSchema}
              onSubmit={(values, { resetForm }) => {
                fileInputRefsalary.current.value = null;
                resetForm();
                const formData = new FormData();
                formData.append("file", values.file);

                formData.append("uploadby", corporateId);
                for (let pair of formData.entries()) {
                  console.log(pair[0], pair[1]);
                }
                setIsLoader(true);
                axios
                  .request(`${APIURL}/salaryuploads`, {
                    method: "POST",
                    data: formData,
                  })
                  .then((response) => {
                    console.log("response::", response);
                    setIsLoader(false);
                    toast.success(response?.data);
                    resetForm();
                    fileInputRefsalary.current.value = null;
                  })
                  .catch((error) => {
                    console.log("error", error);
                    setIsLoader(false);
                    toast.warning("Invalid...");
                    fileInputRefsalary.current.value = null;
                    resetForm();
                  });
              }}
            >
              {({ touched, errors, setFieldValue }) => (
                <>
                  <Form className="pt-4">
                    <div className="row" style={{ alignItems: "center" }}>
                      <div className="col-lg-9 col-md-9 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="file">Upload Salary File</label>
                          <input
                            id="file"
                            name="file"
                            type="file"
                            accept=".xlsx, .xls"
                            ref={fileInputRefsalary}
                            className={`form-control ${
                              touched.file && errors.file ? "is-invalid" : ""
                            }`}
                            onChange={(event) => {
                              const file = event.currentTarget.files[0];
                              setFieldValue("file", file);
                            }}
                          />
                          <ErrorMessage
                            name="file"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-12  d-flex justify-content-center">
                        <a
                          download="Demo.xlsx"
                          href="https://tap.capitaltrust.in:8083/salarytap/salAttdemo"
                          style={{
                            width: "200px",
                            backgroundColor: "#6c757d",
                          }}
                          className="btn btn-secondary mt-3 ml-auto"
                        >
                          Download Demo File
                        </a>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-success mt-3"
                      style={{ backgroundColor: "#66a725" }}
                    >
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </Form>
                </>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageEmploye;
